










import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
const accountManage = namespace('accountManage')
import { getStore } from '@/utils/utils'
import { Protocol } from '@/components'
const commonModules = namespace('commonModules')
@Component({
  name: 'paySever',
  components: {
    Protocol,
  },
})
export default class paySever extends Vue {
  htmlData: string = ''
  @commonModules.Action paySeverProrocol: any
  @commonModules.State paySeverHtml: any
  @commonModules.Action emptyProrocol: any
  @commonModules.State loadingPage
  @Watch('paySeverHtml', { immediate: true })
  onChanged(val: any) {
    this.htmlData = val && val[0] && val[0]['compContent']
  }
  created() {
    if (this.$route.query.flag && this.$route.query.flag == 'emptyFlag') {
      //   this.emptyProrocol({ applyCode: JSON.parse(getStore('userInfo')).credId, accNo: aa })
    } else {
      let aa = this.$route.query.type // 获取  不同银行卡号
      this.paySeverProrocol({
        applyCode: getStore('userInfo') ? JSON.parse(getStore('userInfo')).credId : '',
        accNo: aa,
        compactType: '53',
      })
    }
  }
}
